<template>
  <v-form>
    <v-container fluid>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model="item['amount']['amount']"
            :error-messages="amountErrors"
            :label="$t('amount')"
            @input="$v.item['amount'].$touch()"
            @blur="$v.item['amount'].$touch()"
            type="number"
          />
        </v-col>

        <v-col cols="12" sm="6" md="6">
          <v-select
            v-model="item['amount']['currency']"
            :items="['EUR']"
            :error-messages="amountErrors"
            :label="$t('currency')"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model="item['remittanceInfo']"
            :error-messages="remittanceInfoErrors"
            :label="$t('remittanceInfo')"
            @input="$v.item['remittanceInfo'].$touch()"
            @blur="$v.item['remittanceInfo'].$touch()"
          />
        </v-col>

        <v-col cols="12"></v-col>
      </v-row>

    </v-container>
  </v-form>
</template>

<script>
import has from 'lodash/has';
import { validationMixin } from 'vuelidate';

export default {
  name: 'CreditTransferForm',
  mixins: [validationMixin],
  props: {
    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    // eslint-disable-next-line
    item() {
      return this.initialValues || this.values;
    },

    amountErrors() {
      const errors = [];

      if (!this.$v.item.amount.$dirty) return errors;

      has(this.violations, 'amount') && errors.push(this.violations.amount);


      return errors;
    },
    creditorErrors() {
      const errors = [];

      if (!this.$v.item.creditor.$dirty) return errors;

      has(this.violations, 'creditor') && errors.push(this.violations.creditor);


      return errors;
    },
    remittanceInfoErrors() {
      const errors = [];

      if (!this.$v.item.remittanceInfo.$dirty) return errors;

      has(this.violations, 'remittanceInfo') && errors.push(this.violations.remittanceInfo);


      return errors;
    },

    violations() {
      return this.errors || {};
    }
  },
  validations: {
    item: {
      amount: {
      },
      creditor: {
      },
      remittanceInfo: {
      },
    }
  }
};
</script>
